import { render, staticRenderFns } from "./SecurityTabMatrix.vue?vue&type=template&id=54d3bff8"
import script from "./SecurityTabMatrix.vue?vue&type=script&lang=js"
export * from "./SecurityTabMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports